import React, {useEffect} from 'react';
import { connect } from 'react-redux';

import Page from '../Page';
import PageHeader from '../../modules/PageHeader';
import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import PageSidebar from "../../modules/PageSidebar";
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import SupportForm from "../../forms/Support";
import AlertBox from "../../modules/AlertBox";
import AlertMessage from "../../modules/AlertMessage";

import * as supportActions from '../../../actions/support';

const Support = ({
                     showSubmitConfirmation,
                     location,
                     history,
                     updateServiceId,
                     resetInitialValues,
                 }) => {

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        if (query.get('service_id')) {
            updateServiceId(parseInt(query.get('service_id')));
            history.push('/support');
        }
    }, []);

    useEffect(() => () => {
        resetInitialValues();
    }, []);
    return (
        <Page>
            <PageMeta title="Support Form" />

            <SidebarColumn>
                <PageSidebar />
            </SidebarColumn>

            <ContentColumn>
                <PageHeader>
                    <h1>Support</h1>

                    <span>Use this form to contact us about any queries to do with our services.</span>
                </PageHeader>

                <PageSection>

                    {showSubmitConfirmation ? (
                        <AlertMessage>
                            <AlertBox theme="success">
                                Thank you for submitting a support ticket. You will shortly receive
                                a request to you confirm your account.
                            </AlertBox>
                        </AlertMessage>
                    ) : (
                        <SupportForm />
                    )}
                </PageSection>
            </ContentColumn>
        </Page>
    )
}

const MapStateToProps = (state) => {
    return {
        ...state.support,
    }
}

const MapDispatchToProps = (dispatch) => {
    return {
        updateServiceId(serviceId) {
            dispatch(supportActions.updateInitialValue('service_id', serviceId));
        },
        resetInitialValues() {
            dispatch(supportActions.resetInitialValues());
        }
    }
}

export default connect(MapStateToProps, MapDispatchToProps)(Support);